import ResetFirstTimePassword from "components/ResetPassword/ResetFirstTimePassword";
import { useTranslation } from "react-i18next";

export default function ResetPasswordContainer() {
  const { t } = useTranslation();
  return (
    <>
      <div className="container mb-8">
        <h1>{t("ResetPassword-firstTime-title")}</h1>
        <p>{t("ResetPassword-firstTime-subtitle")}</p>
        <hr />
      </div>
      <ResetFirstTimePassword />
    </>
  );
}
